import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Shared Loading/Spinner Component
 * 
 * Displays a professional loading spinner overlay during app navigation and data loading.
 * Uses Observable pattern for state management.
 * 
 * Usage in parent component:
 * 1. Import: import { LoadingComponent } from 'shared-components';
 * 2. Add to imports: imports: [LoadingComponent]
 * 3. Add to template: <app-loading #loadingComponent></app-loading>
 * 4. Access via ViewChild to control:
 *    @ViewChild('loadingComponent') loadingComponent: LoadingComponent;
 *    
 * 5. Control display:
 *    this.loadingComponent.show();
 *    this.loadingComponent.hide();
 */
@Component({
    selector: 'app-loading',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
    /**
     * Observable stream of loading visibility state
     * Subscribe to this to react to loading state changes
     */
    isVisible$: Observable<boolean>;

    /**
     * Internal subject for managing visibility state
     * @private
     */
    private visibilitySubject = new BehaviorSubject<boolean>(false);

    constructor() {
        this.isVisible$ = this.visibilitySubject.asObservable();
    }

    ngOnInit(): void {
        console.log('LoadingComponent: Initialized');
    }

    /**
     * Show the loading spinner
     */
    show(): void {
        console.log('LoadingComponent: Showing loading spinner');
        this.visibilitySubject.next(true);
    }

    /**
     * Hide the loading spinner
     */
    hide(): void {
        console.log('LoadingComponent: Hiding loading spinner');
        this.visibilitySubject.next(false);
    }

    /**
     * Check current visibility state (synchronous)
     */
    isVisible(): boolean {
        return this.visibilitySubject.value;
    }
}
